import { get } from "src/services/HttpClient";

export async function getData(handler, url, config) {
    const result = await get(url, config);
    if (result && result.success) {
        handler(result.body);
    }
}
